import React from 'react';
import classes from '../../filters.scss';
import BackLink from '../back-link';
export default function DrawerMiddleBlock({
  shouldShowBackLink,
  headerTitle
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.filterSubheaderSection
  }, shouldShowBackLink && /*#__PURE__*/React.createElement(BackLink, null), /*#__PURE__*/React.createElement("h2", {
    className: classes.categoryTitle
  }, headerTitle));
}